export default "__VITE_ASSET__DyqwGXLk__"